import { Map } from 'immutable'
import { DEFAULT_PERSONALITY_ID } from 'services/oracle'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectFeatureTracking = (state) => state.featureTracking || Map()

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectFeatureTrackingData = (state) => selectFeatureTracking(state).get('data', Map())

/**
 * @param {ReduxState} state redux state
 * @returns {number}
 */
export const selectFeatureTrackingGiftExpiringMessage = (state) => selectFeatureTracking(state).getIn(['data', 'giftExpiringMessage'])

/**
 * @param {ReduxState} state redux state
 * @returns {string}
 */
export const selectDefaultOraclePersonalityId = (state) => {
  const value = selectFeatureTrackingData(state).get('defaultOraclePersonalityId')
  return (value || DEFAULT_PERSONALITY_ID).toString()
}
